import * as React from 'react'
import './layout-modal-message.scss'

export const LayoutModalMessage = ({
  headerImage,
  icon,
  onClose,
  title,
  description,
  buttons,
  className = '',
}) => {
  return (
    <div className={`f-modal-message ${className}`}>
      {onClose && (
        <i
          role="button"
          aria-hidden="true"
          aria-label="close modal"
          className="icon2-close f-modal-message__close-icon"
          onClick={onClose}
        />
      )}

      <figure className="f-modal-message__header">
        <img
          src={headerImage?.url}
          alt={headerImage?.description}
          className="f-modal-message__header__image"
        />
      </figure>

      <div className="f-modal-message__body">
        {icon && (
          <img
            src={icon?.url}
            alt={icon.description}
            className="f-modal-message__body__icon"
          />
        )}

        {title && <h2 className="f-modal-message__body__title">{title}</h2>}

        {description && (
          <div className="f-modal-message__body__description">
            {description}
          </div>
        )}

        {buttons && (
          <div className="f-modal-message__body__buttons">{buttons}</div>
        )}
      </div>
    </div>
  )
}
